import React from 'react';

export function useOnClickOutside(ref, handler: (params?) => void, state?: boolean) {
  React.useEffect(() => {
    const listener = (event) => {
      if ((state != null && !state) || !ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
